import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { RewardsBanner } from '@/models';
import { getCountryCodeByTopLevelDomain } from '@/helpers';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgLoyaltyBannerHomepage',
})
export default class CmgLoyaltyBannerHomepage extends Vue {
  get countryCode(): string {
    return getCountryCodeByTopLevelDomain();
  }

  get shouldDisplayBanner(): boolean {
    // if guest
    return this.$services.customer.isLoggedIn() == false;
  }

  get homePageRewardsBanner(): RewardsBanner {
    switch (this.countryCode) {
      case CountryCode.CA:
        return this.$services.config.getHomePagePromoBannerCanada();
      case CountryCode.US:
      default:
        return this.$services.config.getHomePageRewardsBanner();
    }
  }
}
